import { cn } from "~/lib/utils";
import type { GlowColor } from "./_types";
import { glow_style } from "./_config";

interface GlowProps {
  glowColor: GlowColor;
}

export default function Glow({ glowColor }: GlowProps) {
  return (
    <div
      className={cn(
        "bg-gradient absolute -inset-4 bg-linear-to-tr blur-3xl -right-10 -left-20 opacity-20",
        glow_style[glowColor],
      )}
    ></div>
  );
}
